import { Add } from "@mui/icons-material";
import { IconButton, Stack, Typography } from "@mui/material";
import { useGetDaysSupplyForPriceQuery } from "src/api/services/daysSupplyApi";
import { ProductPrice } from "src/api/types";
import DataTable from "src/components/DataTable";
import WhiteCard from "src/components/WhiteCard";
import { useColumns } from "./useColumns";
import { useManageModal } from "src/hooks/useManageModal";
import AddDaysSupplyModal from "./AddDaysSupplyModal";
import { useEffect } from "react";

interface Props {
  price: ProductPrice;
}

const DaysSupply = ({ price }: Props) => {
  const { data = [] } = useGetDaysSupplyForPriceQuery({
    price_id: price.id,
    product_id: price.product_id,
  });
  const columns = useColumns();
  const [open, { handleClose, handleOpen }] = useManageModal();
  const openFromPrice = localStorage.getItem("open-days-supply");

  useEffect(() => {
    if (openFromPrice == null || openFromPrice === "false") return;

    handleOpen();
  }, [handleOpen, openFromPrice]);

  return (
    <>
      <WhiteCard width={"500px"} gap={3}>
        <Stack gap={1}>
          <Stack
            direction={"row"}
            justifyContent={"space-between"}
            alignItems={"center"}
          >
            <Typography fontWeight={600}>Day Supply</Typography>
            <IconButton onClick={handleOpen}>
              <Add color="secondary" />
            </IconButton>
          </Stack>
        </Stack>
        <DataTable columns={columns} data={data} primaryKey="id" />
      </WhiteCard>
      <AddDaysSupplyModal open={open} onClose={handleClose} price={price} />
    </>
  );
};

export default DaysSupply;
